import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Carousel from 'react-bootstrap/Carousel';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={'/hawk-app-adaptive-icon.png'} className="App-logo" alt="logo" />
        <h1 className="titles">Hawk Communications</h1>
        <Container className="pb-2">
          <a
            className="App-link"
            href="https://www.hawksolutions.net/"
            target="_blank"
            rel="noopener noreferrer"
          >
            by Hawk Solutions
          </a>
        </Container>
      </header>
      <section>
        <Container className="px-2">
          <p className="details">
          With the Communications mobile app, community updates, resources, events, polls, and alerts are posted directly to your mobile device, ensuring that you are kept up to date about the latest community news and events. 
          Users have the ability to post urgent alerts to ensure all community members receive real-time information about critical situations. 
          </p>
          <p className="details">
            Click the links below to download
          </p>
          <Container className="py-1">
            <a href="https://apps.apple.com/us/app/hawk-communications/id1562891070">
              <Image src={'/iosDownload.png'} className="download-icons" alt="iosdownload"/>
            </a>
          </Container>
          <Container className="py-1">
            <a href="https://play.google.com/store/apps/details?id=ca.hawksolutions.communications">
              <Image src={'/androidDownload.png'} className="download-icons" alt="androiddownload"/>
            </a>
          </Container>
        </Container>
        <Container className="pt-5">
          <h3 className="titles">Screenshots</h3>
          <Carousel variant="dark">
            <Carousel.Item>
              <img
                className="screenshots"
                src="/appScreenshot5.png"
                alt="Screenshot 5"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="screenshots"
                src="/appScreenshot6.png"
                alt="Screenshot 6"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="screenshots"
                src="/appScreenshot7.png"
                alt="Screenshot 7"
              />
            </Carousel.Item>
          </Carousel>
        </Container>
      </section>
    </div>
  );
}

export default App;
